import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  AEInput,
  AEFile,
  AEAutoComplete
} from "../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { actionTypes as countriesActionTypes } from "../../../Countries/_redux/slice";
import { actionTypes as categoriesActionTypes } from "../../../Categories/_redux/slice";
import { actionTypes as subCategoriesActionTypes } from "../../../Subcategories/_redux/slice";
import { actionTypes as locationsActionTypes } from "../../../Locations/_redux/slice";
import { actionTypes as functionsActionTypes } from "../../../Functions/_redux/slice";
import { fetchEntities as getCategories } from "../../../Categories/_redux/actions";
import { AEMetadata, UAEMetadata, defaultMeta } from "../../../../../_emywork/AEPagination";
import { localField } from "../../../../../_emywork/helpers/UIHelper";
import { fetchEntities as getCountries } from "../../../Countries/_redux/actions";
import {
  fetchEntities as getSubCategories,
  resetEntities as resetSubcategories
} from "../../../Subcategories/_redux/actions";
import { fetchEntities as getLocations, resetEntities as resetLocations } from "../../../Locations/_redux/actions";
import { fetchEntities as getFunctions } from "../../../Functions/_redux/actions";


export function EditForm({ entity, btnRef, saveEntity, validationErrors = [] }) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: entity,
    initialErrors: validationErrors,
    validationSchema: Yup.object().shape({
      title: Yup.string().max(70).required(),
      description: Yup.string().min(400).required(),
      category_id: Yup.number().required(),
      subcategories: Yup.array().min(1).of(Yup.number()),
      images: Yup.array(),
      // country_id: Yup.number(),
      location_id: Yup.number().required(),
      function_id: Yup.number().required(),

      video_url: Yup.string().url(),
      pdf_url: Yup.string().url(),
      website: Yup.string().url(),
      phone: Yup.string(),
      phone_pro: Yup.string(),
      address: Yup.string(),
    }),
    onSubmit: (values) => {
      let { title, description, video_url, pdf_url, website, phone, phone_pro, address,
        subcategories, location_id, function_id, images, } = values
      let entity = {
        user_id, title, description, subcategories, location_id, function_id,
        video_url, pdf_url, website, phone, phone_pro, address
      };
      let files = { emy_product_images: images };
      saveEntity(entity, files)
    }
  });

  const { handleSubmit, getFieldProps, setFieldValue, values, setValues } = formik
  const { countries, categories, subcategories, locations, functions, user_id } = useSelector(state => {
    const { entities: countries } = state.countries[countriesActionTypes.EmyProductFilter]
    const { entities: categories } = state.categories[categoriesActionTypes.EmyProductFilter]
    const { entities: subcategories } = state.subcategories[subCategoriesActionTypes.EmyProductFilter]
    const { entities: locations } = state.locations[locationsActionTypes.EmyProductFilter]
    const { entities: functions } = state.functions[functionsActionTypes.EmyProductFilter]

    return { countries, categories, subcategories, locations, functions, user_id: state.auth.user.id }
  }, shallowEqual)

  useEffect(() => {
    dispatch(getCategories(defaultMeta, categoriesActionTypes.EmyProductFilter))
    dispatch(getCountries(defaultMeta, countriesActionTypes.EmyProductFilter))
    dispatch(getFunctions(defaultMeta, functionsActionTypes.EmyProductFilter))
  }, [dispatch])

  // ------------------ Start Sub Categories
  // useEffect(()=>{
  //   if(values.category_id){
  //     dispatch(
  //       getSubCategories(
  //         new AEMetadata(
  //           {},
  //           {},
  //           {category_id:values.category_id},
  //           ['id',localField()]
  //         ),
  //         subCategoriesActionTypes.EmyProductFilter
  //       ))
  //   }else {
  //     setFieldValue('subcategories',[]);
  //     dispatch(resetSubcategories(subCategoriesActionTypes.EmyProductFilter))
  //   }
  // }, [values.category_id])

  useEffect(() => {
    if (values.category_id) {
      dispatch(
        getSubCategories(
          new UAEMetadata(
            {},
            {},
            { category_id: values.category_id },
            ['id', localField()]
          ),
          subCategoriesActionTypes.EmyProductFilter
        ))
    } else {
      setFieldValue('subcategories', []);
      dispatch(resetSubcategories(subCategoriesActionTypes.EmyProductFilter))
    }
  }, [values.category_id])
  // ------------------ End Sub Categories

  // ------------------ Start Locations
  // useEffect(() => {
  //   if (values.country_id) {
  //     dispatch(getLocations(new AEMetadata({}, {}, { country_id: values.country_id }, ['id', localField()]), subCategoriesActionTypes.EmyProductFilter))
  //   } else {
  //     setFieldValue("location_id", undefined)
  //     dispatch(resetLocations(locationsActionTypes.EmyProductFilter))
  //   }
  // }, [values.country_id])

  useEffect(() => {
    if (values.country_id) {
      dispatch(getLocations(new UAEMetadata({}, {}, { country_id: values.country_id }, ['id', localField()]), subCategoriesActionTypes.EmyProductFilter))
    } else {
      setFieldValue("location_id", undefined)
      dispatch(resetLocations(locationsActionTypes.EmyProductFilter))
    }
  }, [values.country_id])
  // ------------------ End Locations

  const _props = (name, label, type) => {
    let p = {
      name, label,
      field: getFieldProps(name),
      form: formik,
    };

    switch (type) {
      case "autocomplete": {
        p.useId = true;
        p.getOptionLabel = o => o[localField()]
      } break;
    }

    return p
  }

  return (
    <>
      <div className="form form-label-right">
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEFile
              {..._props('images', 'IMAGES')}
              multiple
              accept={'image/*'}
            />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput {..._props('title', 'TITLE')} />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput
              type={"textarea"} rows={10}
              {..._props('description', 'DESCRIPTION')}
            />
            <small>{formatMessage({ id: "VALIDATION.TEXT.LENGTH" }, { value: values.description.length })}</small>
          </div>
        </div>

        <div className="form-group row py-1">
          <div className={`col-lg-${values.category_id ? '6' : '12'}`}>
            <AEAutoComplete
              {..._props('category_id', 'CATEGORY', 'autocomplete')}
              options={categories}
            />
          </div>
          {
            values.category_id &&
            <div className={`col-lg-6`}>
              <AEAutoComplete
                {..._props('subcategories', 'SUBCATEGORY', "autocomplete")}
                options={subcategories} multiple
                disabled={!values.category_id}
              />
            </div>
          }
        </div>
        <div className="form-group row py-1">

          <div className={`flex-lg-fill px-2`}>
            <AEAutoComplete
              {..._props('function_id', 'FUNCTION', 'autocomplete')}
              options={functions}
            />
          </div>

          <div className={`flex-lg-fill px-2`}>
            <AEAutoComplete
              {..._props('country_id', 'COUNTRY', "autocomplete")}
              options={countries}
              validation={false}
            />
          </div>
          {
            values.country_id &&
            <div className={`flex-lg-fill px-2`}>
              <AEAutoComplete
                {..._props('location_id', 'LOCATION', "autocomplete")}
                options={locations}
              />
            </div>
          }
          {
            values.location_id &&
            <div className={`flex-lg-fill px-2`}>
              <AEInput {..._props('address', 'ADDRESS')} />
            </div>
          }
        </div>

        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput {..._props('video_url', 'VIDEO_URL')} />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput {..._props('pdf_url', 'PDF_URL')} />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-4"}>
            <AEInput {..._props('website', 'WEBSITE')} />
          </div>
          <div className={"col-lg-4"}>
            <AEInput {..._props('phone', 'PHONE')} />
          </div>
          <div className={"col-lg-4"}>
            <AEInput {..._props('phone_pro', 'PHONE_PRO')} />
          </div>
        </div>



        <button
          style={{ display: "none" }}
          ref={btnRef}
          onClick={() => { handleSubmit() }}
        />
      </div>
    </>
  );
}

